/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandFacebook = createReactComponent("brand-facebook", "IconBrandFacebook", [
  [
    "path",
    {
      d: "M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3",
      key: "svg-0"
    }
  ]
]);

export { IconBrandFacebook as default };
//# sourceMappingURL=IconBrandFacebook.js.map
